export default {
  name: 'companyObjective',
  miniSave: true,
  uploadFunction: ({ requestFunction, data, saveId }) => {
    return requestFunction.methodRequest(`/companydocuments/objectives`, 'PUT', data);
  },
  restoreSave: (ctx) => {
  }
}
